import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getNewsChannelById, getNewsChannels } from "./actions";

export const newsChannelEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
});

const initialState = newsChannelEntityAdapter.getInitialState({
  totalCount: 0,
  modals: {},
});

export const newsChannelSlice = createSlice({
  name: "newsChannel",
  initialState: initialState,
  reducers: {
    showNewsChannelAddModal: (state, action) => {
      state.modals.newsChannelAddModal = action.payload;
    },
    showNewsChannelDeleteModal: (state, action) => {
      state.modals.newsChannelDeleteModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNewsChannels.fulfilled, (state, action) => {
      if (action.payload.statusCode === 200) {
        if (action.payload.entities?.channel) {
          newsChannelEntityAdapter.setAll(state, action.payload.entities.channel);
          state.totalCount = action.payload.data.totalItems || 0;
        } else {
          state.ids = [];
          state.totalCount = 0;
        }
      }
    });

    builder.addCase(getNewsChannelById.fulfilled, (state, action) => {
      if (action.payload.statusCode === 200) {
        newsChannelEntityAdapter.setOne(state, action.payload.data);
      }
    });
  },
});

export const { showNewsChannelAddModal, showNewsChannelDeleteModal } = newsChannelSlice.actions;

export default newsChannelSlice.reducer;
